import { Component, OnInit, HostListener } from '@angular/core';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { ConfirmationService } from 'primeng/api';
import { BatchHistory, AnimalBatch, WellType } from '../agptesting-newview/model/animalBatch';
import { UnboxedSample } from '../agptesting-newview/model/unboxing-sample';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { Comment } from '../agptesting-newview/model/comment'
import { LabMDM } from '../masterdata/models/lab';
import { saveAs as saveByFileSaver } from "file-saver";
import { BBResponseContainer } from '../carrier/response-container';
import { AnimalSampleOrder, SampleDNA, SampleDNAType, SampleOrderType, SampleStatus, SampleTest } from '../agptesting-newview/model/animalSampleOrder';
import * as cloneDeep from 'lodash/cloneDeep';
import { WorkFlow } from '../masterdata/models/workFlow';


@Component({
  selector: 'app-apgtesting-unboxing',
  templateUrl: './apgtesting-unboxing.component.html',
  styleUrls: ['./apgtesting-unboxing.component.css']
})
export class ApgtestingUnboxingComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  productList: any[] = [];
  labelPrinterList: any = [];
  customerList: any[] = [];
  labelCopies: number[];
  batchSize: number[];
  selectedLabId: string;
  batches: AnimalBatch[] = [];
  selectedBatch: AnimalBatch;
  rowColumns: number[];
  unboxingSampleList: UnboxedSample[] = [];
  unboxingNCDummyList: UnboxedSample[] = [];
  scannedCustomerBarcode: string;
  scannedEurofinsBarcode: string;
  scannedDocumentBarcode: string;
  mapOfDocumentBarcodes = new Map();
  mapOfCustomerBarcodes = new Map();
  mapOfEurofinsBarcodes = new Map();
  mapOfSenders = new Map();
  backupUnboxMap = new Map();
  customerBarcodeAllowed = false;
  documentBarcodeAllowed = false;
  boxIdScanAllowed = false;
  dirty = false;
  barcodeList: any[] = [];
  scannedBarcodes: string[] = [];
  scannedEurofinsBarcodes: string[] = [];
  selectedSamples: UnboxedSample[] = [];
  redoUnboxedSamples: UnboxedSample[] = [];
  redoSampleList: string[] = [];
  deleteSampleFromUnboxedList: string[] = [];
  redoSampleSenders: string[] = [];
  lastScanMessage: any = { str: 0, test: 0, snp: 0 };
  scannedBarcodeToShow: string;
  colorToShowLastScanMessage: boolean;
  batchToSearch: string;
  sampleToSearch: string;
  scannnedBoxId: string;
  loading = false;
  sampleSearchDisabled = true;
  batchSearchDisabled = true;
  mapOfEurofinsinsBarcodes = new Map();
  showScanDialog = false;
  saveScanErrorHeader = '';
  saveScanErrorBody = '';
  focusFunctionToCall: any;
  showSaveScanErrorPopUp = false;
  dummyNCSampleCount: number;
  newComment: Comment;
  selectedLab: LabMDM;
  isSwabDisabled = true;
  unboxedSender: string;
  boxReceivedDate: Date;
  showEditSampleDialog: boolean;
  sampleOrderOptions: Array<any> = [
    { label: 'Sample is OK', value: SampleStatus.RECEIVED, problem: '', disable: false },
    { label: 'Sample was not announced / no order', value: SampleStatus.ADDITIONAL, 
      problem: 'Sample has been received, but no order found in the records!', disable: true },
    { label: 'Sample is not usable / not enough swabs', value: SampleStatus.EMPTY, 
      problem: 'Sample is not usable / not enough swabs', disable: false },
    { label: 'Stored sample not available', value: SampleStatus.TEST_ERROR, 
    problem: 'Stored sample not available', disable: false },
    { label: 'Problem with order', value: SampleStatus.PROBLEM, problem: '', disable: false }
  ];
  sampleOrderDetails: Array<any> = [
    { label: 'Ordered Services:', value: ''},
    { label: 'Ordered Tests:', value: '' },
    { label: 'STR Profile:', value: 'none' },
    { label: 'SNP Profile:', value: 'none' }
  ];

  problemOptions = [
    { value: 'sampleOk', label: 'Sample OK' },
    { value: 'leaked', label: 'Leaked' },
    { value: 'possibleContamination', label: 'Possible contamination' },
    { value: 'nonConformSwapType', label: 'Non-Conform swap type' },
    { value: 'additionalContentInTube', label: 'Additional content in tube' },
    { value: 'twoSwabsPerTube', label: 'Two swabs per tube' },
    { value: 'tubeBarcodeMissing', label: 'Tube barcode missing' },
    { value: 'manuallyWrittenBarcode', label: 'Manually written barcode' },
    { value: 'duplicateBarcode', label: 'Duplicate barcode' },
    { value: 'tfrTubeBarcodeMismatch', label: 'TFR-Tube barcode mismatch' },
    { value: 'missingTFR', label: 'Missing TFR' },
    { value: 'wrongTube', label: 'Wrong tube' },
    { value: 'missingBoxId', label: 'Missing Box ID' },
    { value: 'invalidBoxId', label: 'Invalid Box ID' },
    { value: 'missingExternalBarcode', label: 'Missing External Barcode' },
    { value: 'invalidExternalBarcode', label: 'Invalid External Barcode' },
    { value: 'wrongOrDuplicatePackaging', label: 'Wrong or duplicate packaging' },
    { value: 'barcodeUnavailableInBMS', label: 'Barcode Not Available In BMS' },
    { value: 'other', label: 'Other' }
  ];
  canAnalyze: boolean;
  problem: string;
  comment: string;
  sampleSaveDisable = true;
  maxDate: Date;
  nonConformVisible = false;
  selectedSender: SenderDTO;
  redoSampleMap = new Map<string, number>();
  redoSampleBarcodesMap = new Map();
  object = Object;
  problemsCount: number = 0;
  selectedSampleOrderOption: string;
  selectedSampleOrder: AnimalSampleOrder;
  disableSampleStautsOptions: boolean;
  previousSampleDelivery: string;

  workFlowData: WorkFlow[] = [];
  workFlowList=[];

  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService,
    private confirmationService: ConfirmationService,
    private masterDataService: MasterDataService) { }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    if (this.dirty) {
      event.returnValue = false;
    }
  }

  canDeactivate() {
    if (this.dirty) {
      return confirm("Scanned samples not yet saved. Do you wish to proceed?");
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.maxDate = new Date();
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.findLabDetails();
    this.puid = localStorage.getItem('PUID');
    this.newComment = new Comment();
    this.selectedBatch = new AnimalBatch();
    this.populateSendersInMap();
    this.getWorkFlowList();
    this.productList = [
      { value: 'Animal Batch Test', label: 'Animal Test' }
    ];
    this.dummyNCSampleCount = 0;
    this.selectedBatch.wellType = WellType.WELL96;
    this.selectedBatch.labelCopies = 1;
    this.selectedBatch.product = this.productList[0].value;
    this.filterBatchStatus();
    this.selectedBatch.deliveryReceivedDateTime = new Date();
    this.selectedBatch.redoCount = 0;
    let element = document.getElementById("userID");
    element.focus();
  }

  getWorkFlowList(){
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results =>{
      this.workFlowData = results.data;
      this.workFlowData.forEach(e=>{
        this.workFlowList.push({label: e.workFlowName, value: e.workFlowName});
      });
    },
    (error: any) => {
      this.showError(error);
    });
  }

  getSelectedWorkflow(){
    let selectedWorkFlowData: WorkFlow[] = this.workFlowData.filter(e=> e.displayName === this.selectedBatch.workFlowName );
    if(!selectedWorkFlowData || selectedWorkFlowData.length ==0) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Work flow Not Found', detail: 'Please configure Work flow '+ this.selectedBatch.workFlowName + ' to continue with this batch.' });
    }else{
      this.selectedBatch.workFlow = selectedWorkFlowData[0];
    }
  }

  showBatchInfo(event: any) {
    this.selectedSamples = [];
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Discard Changes?',
        accept: () => {
          this.showBatchInfoAction(this.selectedLabId, event);
        },
        reject: () => { }
      });
    } else {
      this.showBatchInfoAction(this.selectedLabId, event);
    }

  }

  showBatchInfoAction(labId: any, event: any) {
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId, event.data.batchID).subscribe(
      results => {
        this.selectedBatch = results.data;
        this.newComment = this.getPreviewComment(this.selectedBatch);
        if (this.selectedBatch.deliveryReceivedDateTime) {
          this.selectedBatch.deliveryReceivedDateTime = new Date(this.selectedBatch.deliveryReceivedDateTime);
        }
        this.getSelectedSender();
        this.unboxingSampleList = [];
        this.redoSampleList = [];
        this.redoUnboxedSamples = [];
        this.deleteSampleFromUnboxedList = [];
        this.selectedSamples = [];
        this.initializeMapsForShowingBatch();
        this.focusBarCodeBox();
        this.batchToSearch = '';
        this.sampleToSearch = '';
        this.updateOrderAndProblemCount();
      },
      error => {
        this.showError(error);
      }
    );
  }

  createMapOutOfUnboxingSamples(unboxSamples: UnboxedSample[]) {
    this.mapOfDocumentBarcodes = new Map();
    this.mapOfCustomerBarcodes = new Map();
    this.mapOfEurofinsBarcodes = new Map();
    unboxSamples.forEach(sample => {
      if (sample.documentBarcode != null && sample.documentBarcode != undefined && sample.documentBarcode.trim() != '') {
        this.mapOfDocumentBarcodes.set(sample.documentBarcode, '');
      }
      if (sample.customersBarcode != null && sample.customersBarcode != undefined && sample.customersBarcode.trim() != '') {
        this.mapOfCustomerBarcodes.set(sample.customersBarcode, '');
      }
      if (sample.eurofinsBarcode != null && sample.eurofinsBarcode != undefined && sample.eurofinsBarcode.trim() != '') {
        this.mapOfEurofinsBarcodes.set(sample.eurofinsBarcode, '');
      }
    });
  }

  isPUIDPresnt() {
    if (this.puid) {
      return true;
    }
    return false;
  }

  clearAllFieldsForNewBatch() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to continue' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Discard Changes?',
        accept: () => {
          this.clearAllFieldsForNewBatchAction();
        },
        reject: () => { }
      });
    } else {
      this.clearAllFieldsForNewBatchAction();
    }
  }

  clearAllFieldsForNewBatchAction() {
    this.dummyNCSampleCount = 0;
    this.selectedSamples = [];
    this.dirty = false;
    this.selectedBatch = new AnimalBatch();
    this.setBatchSender();
    this.selectedBatch.labelCopies = 1;
    this.selectedBatch.product = this.productList[0].value;
    this.selectedBatch.comments = [];
    this.newComment = new Comment();
    this.selectedBatch.wellType = WellType.WELL96;
    this.lastScanMessage = { str: 0, test: 0, snp: 0 };
    this.scannedBarcodeToShow = '';
    this.intializationOfUnboxing();
    this.selectedBatch.deliveryReceivedDateTime = new Date();
    this.batchToSearch = '';
    this.sampleToSearch = '';
    let element = document.getElementById("batchID");
    this.problemsCount = 0;
    element.focus();
  }


  saveBatch(saveButton: string) {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to change status' });
      return;
    }
    if (!this.selectedBatch.sender) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No sender selected', detail: 'Please select a sender before saving batch' });
      return;
    }
    if (this.selectedLab && this.selectedLab.batchIDRegex && !this.selectedBatch.batchID.match(this.selectedLab.batchIDRegex.trim())) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Pattern for BatchID', detail: 'BatchID does not match with the configured Pattern in MDM' });
      return;
    }
    if (!this.selectedBatch.workFlowName || !this.selectedBatch.workFlow) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No Workflow selected', detail: 'Please select Workflow before saving batch' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Create Batch?',
        accept: () => {
          this.savebatchConfirm(saveButton);
        },
        reject: () => { }
      });
    } else {
      this.savebatchConfirm(saveButton);
    }

  }

  savebatchConfirm(saveButton: string) {
    let shortName = this.selectedSender.senderShortName ? ' (' + this.selectedSender.senderShortName + ') ' : '';
    let currentMessage = 'Batch ' + this.selectedBatch.batchID + ' Will be created with sender ' + this.selectedBatch.sender + shortName + '. Are you sure you want to continue?';
    this.confirmationService.confirm({
      message: currentMessage,
      header: 'Discard Changes?',
      accept: () => {
        this.saveBatchAction(saveButton);
      },
      reject: () => { }
    });
  }

  saveBatchAction(saveButton) {
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.labName = this.selectedLab.name;
    this.selectedBatch.batchID = this.selectedBatch.batchID.trim();
    this.selectedBatch.statusOfTheBatch = saveButton;
    this.selectedBatch.previousStatusOfTheBatch = saveButton;
    this.selectedBatch.receptionDateTime = new Date();
    this.selectedBatch.mergeGroup = this.mapOfSenders.get(this.selectedBatch.sender).mergeGroup ? this.mapOfSenders.get(this.selectedBatch.sender).mergeGroup : "";
    this.selectedBatch.rnaPlateID = this.selectedBatch.batchID;
    if (this.newComment && this.newComment.userComment && this.newComment.userComment.trim() != '') {
      if (!this.selectedBatch.comments || this.selectedBatch.comments.length == 0) {
        this.selectedBatch.comments = [];
        this.intializeNewComment();
        this.selectedBatch.comments.push(this.newComment);
      } else {
        if (this.selectedBatch.comments[this.selectedBatch.comments.length - 1].userComment != this.newComment.userComment) {
          this.intializeNewComment();
          this.selectedBatch.comments.push(this.newComment);
        }
      }
    }
    let history: BatchHistory = new BatchHistory();
    history.currentBatch = history.originalBatch = this.selectedBatch.batchID;
    this.selectedBatch.history = [];
    this.selectedBatch.history.push(history);

    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        this.selectedBatch = result.data;
        if (this.selectedBatch.deliveryReceivedDateTime) {
          this.selectedBatch.deliveryReceivedDateTime = new Date(this.selectedBatch.deliveryReceivedDateTime);
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Batch Saved!',
          detail: 'Batch ' + this.selectedBatch.batchID + ' has been saved.',
        });
        this.selectedSamples = [];
        this.initializeMapsForShowingBatch();
        this.focusBarCodeBox();
        return;
      },
      error => {
        this.showError(error);
      }
    );
  }

  filterBatchStatus() {
    this.apgTestingService.filterBatches("CREATE_BATCH,SCAN_COMPLETE", this.selectedLabId).subscribe(
      results => {
        this.batches = results.data;
      },
      error => {
        this.showError(error);
      }
    )

  }

  completeScan(scanCompleteButton: string) {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to change status' });
      return;
    }
    
    this.selectedSamples = [];
    let scanmessage = 'These scanned samples cannot be removed later. Are you sure you want to proceed with scan complete?';
    if (this.mapOfCustomerBarcodes.size != this.mapOfEurofinsBarcodes.size || this.mapOfDocumentBarcodes.size != this.mapOfEurofinsBarcodes.size) {
      scanmessage = 'Not all samples have Document or External barcodes. Also these scanned samples cannot be removed later. Are you sure you want to proceed with scan complete?';
    }
    this.confirmationService.confirm({
      message: scanmessage,
      header: 'Confirm Scan Complete',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.prepareBatchForScan(scanCompleteButton);
        this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
          result => {
            this.updateTheBatchDetails(result.data);
          },
          error => {
            if (this.errorHandler.isOptimisticLockException(error)) {
              this.handleOptimisticLock(this.selectedBatch.batchID);
            } else {
              this.showErrorOnFailToSaveBatch(error);
            }
          }
        );
      },
      reject: () => {
      }
    });
  }

  updateTheBatchDetails(data: any) {
    this.selectedBatch = data;
    this.copyToUnbox();
    this._messagesService.addSuccessMessage({
      severity: 'success', summary: 'Scan Completed',
      detail: 'Batch ' + this.selectedBatch.batchID + ' has been scanned.',
    });
    this.initializeScanningDisplayVariables();
    this.updateOrderAndProblemCount();
  }

  showErrorOnFailToSaveBatch(error: any) {
    this.saveScanErrorHeader = "Scan Complete Error";
    this.saveScanErrorBody = error.error.bbApiError.message;
    this.showSaveScanErrorPopUp = true;
  }

  removeSelectedSamples() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to change status' });
      return;
    }
    if (this.selectedSamples == null || this.selectedSamples == undefined || this.selectedSamples.length == 0) {
      return;
    }

    let sampleBarcodesToBeDeleted = [];
    this.selectedSamples.forEach(sample => {
      if (this.backupUnboxMap.has(sample.eurofinsBarcode)) {
        sampleBarcodesToBeDeleted.push(sample.eurofinsBarcode);
      }
    })
    let messageForDeletion = '';

    if (sampleBarcodesToBeDeleted.length != 0) {
      messageForDeletion = 'Eurofins barcodes : ' + sampleBarcodesToBeDeleted.join(", ") + ' have been SCAN COMPLETED but will be removed.';
    } else {
      messageForDeletion = 'Selected eurofins barcodes will be removed!';
    }

    let messageOnDialog = messageForDeletion + ' Do you wish to proceed?';

    this.confirmationService.confirm({
      message: messageOnDialog,
      header: 'Confirm Delete',
      accept: () => {

        this.unboxingSampleList = this.unboxingSampleList.filter(sample => {
          if (this.selectedSamples.includes(sample) && this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
            return true;
          } else if (this.selectedSamples.includes(sample) && !this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
            this.redoSampleList = this.redoSampleList.filter(barcode => barcode != sample.eurofinsBarcode);
            return false;
          } else if (!this.selectedSamples.includes(sample) && this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
            return true;
          } else {
            return true;
          }
        });
        this.selectedSamples.forEach(sample => {
          this.mapOfCustomerBarcodes.delete(sample.customersBarcode);
          this.mapOfDocumentBarcodes.delete(sample.documentBarcode);
          this.mapOfEurofinsBarcodes.delete(sample.eurofinsBarcode);
          this.mapOfDocumentBarcodes.delete(sample.documentBarcode);
          this.addToredoRemoveList(sample);
        });
        this.selectedBatch.unboxedSamples = this.unboxingSampleList;
        this.updateOrderAndProblemCount();
        this.selectedSamples = [];
      },
      reject: () => {
        this.selectedSamples = [];
      }
    });
  }

  getSampleSizeClass() {
      return "lastMessageLabelInRange";
  }

  initializeScanningDisplayVariables() {
    this.scannedCustomerBarcode = '';
    this.scannedEurofinsBarcode = '';
    this.scannedDocumentBarcode = '';
    this.scannnedBoxId = '';
    this.lastScanMessage = { str: 0, test: 0, snp: 0 };
    this.scannedBarcodeToShow = '';
    this.dirty = false;
  }

  intializationOfUnboxing() {
    this.unboxingSampleList = [];
    this.mapOfCustomerBarcodes = new Map();
    this.mapOfDocumentBarcodes = new Map();
    this.mapOfEurofinsBarcodes = new Map();
    this.backupUnboxMap = new Map();
    this.initializeScanningDisplayVariables();
  }

  prepareBatchForScan(scanCompleteButton: string) {
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.statusOfTheBatch = scanCompleteButton;
    this.selectedBatch.previousStatusOfTheBatch = scanCompleteButton;
    this.selectedBatch.scanCompleteDateTime = new Date();
    this.selectedBatch.redoUnboxedSamples = [];
    this.selectedBatch.unboxedSamples = [];
    this.selectedBatch.unboxedSamplesForReceived = [];
    this.unboxingSampleList.forEach(unBoxedSample => {
      if (unBoxedSample.redoSampleFlag) {
        this.selectedBatch.redoUnboxedSamples.push(unBoxedSample);
      } else {
        if (!this.backupUnboxMap.has(unBoxedSample.eurofinsBarcode) && unBoxedSample.eurofinsBarcode != 'NC-DUMMY') {
          this.selectedBatch.unboxedSamplesForReceived.push(unBoxedSample);
        }
        this.selectedBatch.unboxedSamples.push(unBoxedSample);
      }
    });
    this.selectedBatch.redoSampleList = this.redoSampleList;
    this.selectedBatch.deleteSampleFromUnboxedList = this.deleteSampleFromUnboxedList;
  }

  copyToUnbox() {
    this.unboxingNCDummyList = [];
    this.unboxingSampleList = [];
    this.redoUnboxedSamples = [];
    this.redoSampleList = [];
    this.deleteSampleFromUnboxedList = [];
    this.backupUnboxMap = new Map();
    if (this.selectedBatch.unboxedSamples) {
      this.selectedBatch.unboxedSamples.forEach(val => {
        if (!val.problem || val.problem == '') {
          val.canAnalyze = true;
        }
        this.unboxingSampleList.push(Object.assign({}, val));
        this.backupUnboxMap.set(val.eurofinsBarcode, '');
      });
    }
  }

  focusBarCodeBox() {
    let element = document.getElementById("barcodeBox");
    if (element) {
      element.focus();
    }
  }

  initializeMapsForShowingBatch() {
    this.copyToUnbox();
    if (this.unboxingSampleList.length != 0) {
      this.createMapOutOfUnboxingSamples(this.unboxingSampleList);
      this.initializeScanningDisplayVariables();
    } else {
      this.intializationOfUnboxing();
      this.initializeScanningDisplayVariables();
    }
  }

  showNonConformPopUp() {
    this.canAnalyze = this.selectedSamples[0].canAnalyze;
    this.problem = this.selectedSamples[0].problem;
    this.comment = this.selectedSamples[0].comment;
    this.nonConformVisible = true;
    if (!this.backupUnboxMap.has(this.selectedSamples[0].eurofinsBarcode)) {
      this.sampleSaveDisable = false;
    }
  }

  hideNonConformPopUp() {
    this.selectedSamples[0].canAnalyze = this.canAnalyze;
    this.selectedSamples[0].problem = this.problem;
    this.selectedSamples[0].comment = this.comment;
    this.nonConformVisible = false;
    this.selectedSamples = [];
    this.sampleSaveDisable = true;
  }

  clearSelection() {
    this.selectedSamples = [];
  }

  isSearchForBatchEnabled(): boolean {
    return !(this.batchToSearch != null && this.batchToSearch != undefined && this.batchToSearch != "");
  }

  searchForBatch() {
    if (this.batchSearchDisabled) {
      this.batchSearchDisabled = false;
      return;
    }

    if (this.isSearchForBatchEnabled()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
      return;
    }
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId, this.batchToSearch.trim()).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.newComment = this.getPreviewComment(this.selectedBatch);
          this.sampleToSearch = '';
          this.batchToSearch = '';
          this.getSelectedSender();
          this.unboxingSampleList = [];
          this.selectedSamples = [];
          this.initializeMapsForShowingBatch();
          this.focusBarCodeBox();
          this.batchSearchDisabled = true;
          this.updateOrderAndProblemCount();
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with BatchID ' + this.batchToSearch });
        }

      },
      error => {
        this.showError(error);
      }
    );
  }

  isSearchForSampleEnabled(): boolean {
    return !(this.sampleToSearch != null && this.sampleToSearch != undefined && this.sampleToSearch != "");
  }

  searchForSample() {
    if (this.sampleSearchDisabled) {
      this.sampleSearchDisabled = false;
      return;
    }

    if (this.isSearchForSampleEnabled()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Sample ID Empty', detail: 'Please enter Sample ID to search' });
      return;
    }
    this.apgTestingService.getBatchWithSampleUnboxing(this.sampleToSearch.trim(), this.selectedLabId).subscribe(
      result => {
        if (result && result.data != null) {
          this.selectedBatch = result.data;
          this.newComment = this.getPreviewComment(this.selectedBatch);
          this.batchToSearch = '';
          this.initializeMapsForShowingBatch();
          this.focusBarCodeBox();
          this.getSelectedSender();
          this.sampleSearchDisabled = true;
          this.sampleToSearch = '';
          this.updateOrderAndProblemCount();
        } else {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Batch Found', detail: 'No Batch found for given sample' });
        }

      },
      error => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'No Batch found for given sample' });
      }
    );
  }

  saveDisabledIf() {
    return !(this.selectedBatch.statusOfTheBatch
      && ['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch));
  }

  createBatchDisabledIf() {
    return (this.unboxingSampleList.length > 0
      || (this.selectedBatch.unboxedSamples && this.selectedBatch.unboxedSamples.length > 0));
  }

  populateSendersInMap() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfSenders.set(key, value);
            let tempSender: any = value;
            let labelValue = tempSender.senderShortName ? tempSender.senderShortName : key;
            this.customerList.push({ label: labelValue, value: key });
          });
          this.setBatchSender();
          this.selectedSender = this.mapOfSenders.get(this.customerList[0].value);
          this.customerList.sort((a, b) => a.label.localeCompare(b.label));
        }
      },
      error => {
        this.showError(error);
      }
    );
  }

  setBatchSender() {
    if (this.customerList.length == 1) {
      this.selectedBatch.sender = this.customerList[0].value;

    } else {
      this.selectedBatch.sender = null;
    }
  }

  getSelectedSender() {
    this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
    if (!this.selectedSender) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Sender Not Found', detail: 'Please configure Sender ' + this.selectedBatch.sender + ' to continue with this batch.' });
      return;
    }
    if (!this.selectedBatch._id) {
      this.selectedBatch.rushSample = (this.selectedSender.defaultPriority == "Rush" || this.selectedSender.defaultPriority == "SuperRush");
      this.selectedBatch.superRush = this.selectedSender.defaultPriority == "SuperRush";
    }
  }

  checkIsSuperRush() {
    return this.selectedBatch.superRush;
  }
  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }

  validateEurofinsBarcode() {
    const isBarcodeAlreadyPresent = this.unboxingSampleList.find((sample: UnboxedSample) => sample.eurofinsBarcode === this.scannedEurofinsBarcode);
    if (isBarcodeAlreadyPresent) {
      this.saveScanErrorHeader = 'Duplicate Scan';
      this.saveScanErrorBody = this.scannedEurofinsBarcode + ' has already been scanned.';
      this.focusFunctionToCall = this.focusBarCodeBox;
      this.scannedEurofinsBarcode = '';
      this.showScanDialog = true;
      return false;
    }
    return true;
  }

  isScanElementDisabled() {
    return (this.selectedBatch && this.selectedBatch.receptionDateTime && this.selectedBatch.puidUnboxing);
  }

  disableSwab($event) {
    this.isSwabDisabled = $event.checked == false;
  }

  isRegisteredUnboxedSamples(eurofinsBarcode: string) {
    return this.mapOfEurofinsinsBarcodes.has(eurofinsBarcode);
  }

  isRegisteredUnboxedSamplesStyle(sample: UnboxedSample) {
    const { strOrder, strPOrder} = sample;
    let color: string = 'color10';
    if (strOrder && sample.order.length ==1) {
      color = 'color1';
    } else if (strOrder && strPOrder && sample.order.length ==2) {
      color = 'color2';
    } else if (strPOrder && sample.order.length==1) {
      color = 'color3';
    }else{
      color =this.isRegisteredUnboxedSamplesStyles(sample,color);
    }
    return color;
  }
  isRegisteredUnboxedSamplesStyles(sample:UnboxedSample,color:string){
    const { strOrder, snpOrder, testOrder,snpPOrder} = sample;
     if(strOrder && testOrder &&!snpOrder && !snpPOrder){
      color = 'color4';
    }else if(testOrder && !sample.reused){
      color = 'color5';
    }else if(testOrder && sample.reused){
      color = 'color6'
    }else if(snpOrder && sample.order.length ==1){
      color = 'color7';
    }else if(snpOrder && strOrder && sample.order.length == 2){
      color = 'color8'
    }else if(!strOrder && snpOrder ){
      color = 'color9';
    }
    return color;
  }

  saveSamples() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    this.selectedSamples = [];
    this.selectedBatch.redoUnboxedSamples = [];
    this.selectedBatch.unboxedSamples = [];
    this.selectedBatch.unboxedSamplesForReceived = [];
    this.unboxingSampleList.forEach(unBoxedSample => {
      if (unBoxedSample.redoSampleFlag) {
        this.selectedBatch.redoUnboxedSamples.push(unBoxedSample);
      } else {
        if (!this.backupUnboxMap.has(unBoxedSample.eurofinsBarcode) && unBoxedSample.eurofinsBarcode != 'NC-DUMMY') {
          this.selectedBatch.unboxedSamplesForReceived.push(unBoxedSample);
        }
        this.selectedBatch.unboxedSamples.push(unBoxedSample);
      }
    });
    this.selectedBatch.redoSampleList = this.redoSampleList;
    this.selectedBatch.deleteSampleFromUnboxedList = this.deleteSampleFromUnboxedList;
    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        this.selectedBatch = result.data;
        this.copyToUnbox();
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Samples saved',
          detail: 'Batch ' + this.selectedBatch.batchID + ' has been saved.',
        });
        this.initializeScanningDisplayVariables();
        this.updateOrderAndProblemCount();
      },
      error => {
        if (this.errorHandler.isOptimisticLockException(error)) {
          this.handleOptimisticLock(this.selectedBatch.batchID);
        } else {
          this.saveScanErrorHeader = "Scan Complete Error";
          this.saveScanErrorBody = error.error.bbApiError.message;
          this.showSaveScanErrorPopUp = true;
        }
      }
    );
  }

  isSaveBatchDisabledIf() {
    return !(this.selectedBatch.statusOfTheBatch && this.selectedBatch.statusOfTheBatch == 'CREATE_BATCH');
  }

  closeScanErrorPopUp() {
    this.showScanDialog = false;
  }

  closeScanSaveErrorPopUp() {
    this.showSaveScanErrorPopUp = false;
  }

  focusDeciderAfterHide() {
    this.focusFunctionToCall();
  }


  getPreviewComment(batch: AnimalBatch) {
    let comment = new Comment();
    if (batch.comment) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
    } else if (batch.comments && batch.comments.length > 0) {
      comment = Object.assign({}, batch.comments[batch.comments.length - 1]);
    } else {
      comment.userComment = '';
    }
    return comment;
  }

  intializeNewComment() {
    this.newComment.puid = this.puid;
    this.newComment.batchId = this.selectedBatch.batchID;
    this.newComment.commentDate = new Date();
  }

  private handleOptimisticLock(batchID: string) {
    this._messagesService.addWarningMessage({
      severity: 'warn', summary: 'Parallel updation occurred',
      detail: 'Batch ' + this.selectedBatch.batchID + ' has been modified by other user. Scanned samples have been merged',
    });
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId, batchID).subscribe(
      results => {
        this.selectedBatch = results.data;
        this.addMissedSamplesDuringOptimisticLockError();
        this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
          result => {
            this.updateTheBatchDetails(result.data);
          },
          error => {
            this.showErrorOnFailToSaveBatch(error);
          });
      },
      error => {
        this.showError(error);
      }
    );
  }

  private addMissedSamplesDuringOptimisticLockError() {
    let missedSampels = this.unboxingSampleList.filter(sample => !this.backupUnboxMap.has(sample.eurofinsBarcode) && sample.eurofinsBarcode != 'NC-DUMMY');
    missedSampels.forEach(sample => {
      if (!(this.selectedBatch.unboxedSamples.some(s => s.eurofinsBarcode === sample.eurofinsBarcode))) {
        this.selectedBatch.unboxedSamples.unshift(sample);
      }
    });
    this.unboxingNCDummyList.forEach(ncDummy => {
      this.selectedBatch.unboxedSamples.unshift(ncDummy);
    });
    this.selectedBatch.unboxedSamplesForReceived = missedSampels;
  }

  setLabelFocus(errorTextArea: HTMLInputElement) {
    setTimeout(() => {
      errorTextArea.focus();
    }, 50);
  }

  findLabDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe(
      result => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'LabÂ notÂ found!', detail: 'ContactÂ AdministratorÂ toÂ resolveÂ thisÂ issue.' });
          return;
        }
        this.selectedLab = result.data;
      },
      error => {
        this.showError(error);
      }
    );
  }

  downloadSamples() {
    this.apgTestingService.downloadRedoFiles(this.selectedLabId).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, "RedoSamples.xlsx");
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Redo file have been downloaded',
        });
      },
      error => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Download Failed',
          detail: 'Could not download redo file.',
        });
      });
  }
  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }
  isRedoSamplesAvailable() {
    return this.redoSampleSenders.length > 0;
  }

  getNoOfRedoSamplesForSender(sender: string) {
    return this.redoSampleMap.get(sender);
  }
  addToredoRemoveList(sample) {
    if (sample.redoSampleFlag) {
      this.deleteSampleFromUnboxedList.push(sample.eurofinsBarcode);
    }
  }

  verifyBarcode() {
    if (this.validateEurofinsBarcode()) {
      this.loading = true;
      this.apgTestingService.getSampleOrder(this.scannedEurofinsBarcode, this.selectedLabId).subscribe((response: BBResponseContainer) => {
      const { data = {} } = response;
      if(data.order && data.order.length>0){
        var diff: string[] = data.order.filter(o => this.selectedBatch.workFlow.product.indexOf(o)>=0);
      if(diff && diff.length>0){
        const strOrder = this.isOrderPresent(data, SampleOrderType.STR);
        const testOrder = this.isOrderPresent(data, SampleOrderType.TEST);
        const snpOrder = this.isOrderPresent(data, SampleOrderType.SNP);
        const strPOrder = this.isOrderPresent(data, SampleOrderType.STRP);
        const snpPOrder = this.isOrderPresent(data, SampleOrderType.SNPP);
        const status = this.getSampleStatus(data); 
        var delivery:string;
        if(data && data.delivery){
          delivery = data.delivery;
          this.previousSampleDelivery = data.delivery;
        }else{
          delivery = this.previousSampleDelivery;
        }
        this.unboxingSampleList.unshift({ 
          eurofinsBarcode: this.scannedEurofinsBarcode, 
          strOrder: strOrder, 
          testOrder: testOrder, 
          snpOrder: snpOrder, 
          strPOrder:strPOrder,
          snpPOrder:snpPOrder,
          status: status,
          delivery: delivery,
          receivedDate: new Date(),
          order: data.order,
          tests: data.tests,
          dna: data.dna,
          reused:data.reused
        });
      
        this.incrementOrderOrProblemCount({ str: strOrder, test: testOrder, snp: snpOrder });
        this.scannedEurofinsBarcode = '';
        this.loading = false;
      }else{
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Sample does not belong to this workflow',
          detail: 'Configured workflow does not have atleast one product matching with sample orders '+data.order
          })
          this.loading=false;
      }
    }else{
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid order',
        detail: 'An order exists with barcode '+this.scannedEurofinsBarcode+', but with no order'
      })
      this.loading=false;
    }
    }, (error: any) => {
        this.showError(error);
        this.loading = false;
      }); 
    
    }
  }
  getSampleStatus(data: any) {
    const { order = [] } = data;
    return (order && order.length) ? SampleStatus.RECEIVED : SampleStatus.ADDITIONAL;
  }

  incrementOrderOrProblemCount({ str, test, snp }) {
    const strCount = str ? this.lastScanMessage.str + 1 : this.lastScanMessage.str;
    const testCount = test ? this.lastScanMessage.test + 1 : this.lastScanMessage.test;
    const snpCount = snp ? this.lastScanMessage.snp + 1 : this.lastScanMessage.snp;
    this.lastScanMessage = { snp: snpCount, test: testCount, str: strCount };
    if (!str && !test && !snp) {
      this.problemsCount++;
    }
  }

  updateOrderAndProblemCount() {
    const { str, snp, test, problem } = this.unboxingSampleList.reduce((acc: any, sample: UnboxedSample) => {
      acc.str = sample.strOrder ? acc.str + 1 : acc.str;
      acc.test = sample.testOrder ? acc.test + 1 : acc.test;
      acc.snp = sample.snpOrder ? acc.snp + 1 : acc.snp;
      if (!sample.strOrder && !sample.testOrder && !sample.snpOrder) {
        acc.problem = acc.problem + 1;
      }
      return acc;
    }, { str: 0, test: 0, snp: 0, problem: 0 });
    this.lastScanMessage = { str, snp, test };
    this.problemsCount = problem;
  }

  isOrderPresent(data: any, orderName: string) {
    return data.order ? data.order.findIndex((order: string) => order === orderName) !== -1 : false;
  }

  setFocusOnProblemTextField() {
    setTimeout(() => {
      const element: HTMLInputElement = document.getElementById('problemValue') as HTMLInputElement;
      if (element) {
        element.focus();
      }
    }, 500);
  }

  cleanUpAfterClosingPopup() {
    this.showEditSampleDialog = false;
    this.sampleOrderOptions[4].problem = '';
  }

  saveSampleOrder() {
    this.loading = true;
    let unboxingSample: UnboxedSample = cloneDeep(this.selectedSamples[0]);
    unboxingSample.status = this.selectedSampleOrderOption;
    if(this.selectedSampleOrderOption === SampleStatus.PROBLEM){
      unboxingSample.problem = this.sampleOrderOptions[4].problem;
    }else{
      unboxingSample.problem = this.sampleOrderOptions.find(x=>x.value===this.selectedSampleOrderOption).problem;
    }
    if(this.selectedBatch.statusOfTheBatch != 'CREATE_BATCH'){
      this.confirmationService.confirm({
        message: "Do you really want to update the sample "+unboxingSample.eurofinsBarcode,
        header: 'Sample Update',
        icon: 'fa fa-question-circle',
        accept: () => {
            this.updateUnboxedSample(unboxingSample);
        },
        reject: () => {
          this.loading = false;
        }
      });
    }else{
      this.updateUnboxedSample(unboxingSample);
    }
  }

  updateUnboxedSample(unboxingSample: UnboxedSample){
    this.apgTestingService.updateUnboxingSampleStatus(this.selectedBatch.batchID, this.selectedLabId, unboxingSample)
    .subscribe((response: BBResponseContainer) => {
      const { data = {} } = response;
      this.loading = false;
      this.selectedBatch = data;
      this.findAndUpdateInUnboxedSampleList(unboxingSample);
      this.selectedSamples = [];
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Sample update',
        detail: `Sample barcode ${unboxingSample.eurofinsBarcode} has been updated`,
      });
    }, (error: any) => {
      this.showError(error);
      this.loading = false;
    });
    this.cleanUpAfterClosingPopup();
  }

  findAndUpdateInUnboxedSampleList(unboxedSample: UnboxedSample) {
    const sampleIndex: number = this.unboxingSampleList.findIndex((sample: UnboxedSample) => sample.eurofinsBarcode === unboxedSample.eurofinsBarcode);
    if (sampleIndex !== -1) {
      this.unboxingSampleList[sampleIndex] = unboxedSample;
    }
  }

  editSampleOrder() {
    if (this.selectedSamples && this.selectedSamples.length === 1) {
      this.loading = true;
      const { eurofinsBarcode } = this.selectedSamples[0];
      const { delivery } = this.selectedSamples[0];
      this.apgTestingService.getSampleOrderDetails(eurofinsBarcode, this.selectedLabId, delivery).subscribe((response: BBResponseContainer) => {
        const { data = {} } = response;
        this.selectedSampleOrder = data;
        this.setSampleStatusAndProblem();
        this.setSampleOrderTestsValue();
        this.setSnpAndStrValues();
        this.enableOrDisableSampleStatusOptions();
        this.loading = false;
        this.showEditSampleDialog = true;
      }, (error: any) => {
        this.showError(error);
        this.loading = false;
      })
    }
  }

  enableOrDisableSampleStatusOptions() {
    this.sampleOrderOptions.forEach(option=>{
      if(option.value != SampleStatus.ADDITIONAL){
        option.disable = (this.selectedSampleOrderOption === SampleStatus.ADDITIONAL) ? true : false;
      }
    })
  }

  setSampleStatusAndProblem() {
    const { problem = '', status = '' } = this.selectedSamples[0];
    const { order = [] } = this.selectedSampleOrder;
    if (status && status.trim().length) {
      if (status === SampleStatus.PROBLEM) {
        this.sampleOrderOptions[4].problem = problem;
      }
      this.selectedSampleOrderOption = status;
    } else if (order && order.length) {
      this.selectedSampleOrderOption = SampleStatus.RECEIVED;
    } else {
      this.selectedSampleOrderOption = SampleStatus.ADDITIONAL;
    }
  }

  setSampleOrderTestsValue() {
    const { order = [] } = this.selectedSampleOrder;
    const { tests = [] } = this.selectedSampleOrder;
    if(order&&order.length>0) {
      this.sampleOrderDetails[0].value = order.map(x => x).join(', ');
    }else {
      this.sampleOrderDetails[0].value = '';
    }
    if (tests) {
      this.sampleOrderDetails[1].value = tests.map((test: SampleTest) => test.code).join(', ');
    } else {
      this.sampleOrderDetails[1].value = '';
    }
  }

  setSnpAndStrValues() {
    const { dna = {} } = cloneDeep(this.selectedSampleOrder);
    let { father = {}, mother = {} } = (dna || {}) as SampleDNA;
    if(!father || father==null) father = {} as SampleDNA;
    if(!mother || mother==null) mother = {} as SampleDNA;
    (father as any).label = 'Father';
    (mother as any).label = 'Mother';
    this.sampleOrderDetails[2].value = this.getDNAOrderTypeNames([father as SampleDNAType, mother as SampleDNAType], 'isagSTR');
    this.sampleOrderDetails[3].value = this.getDNAOrderTypeNames([father as SampleDNAType, mother as SampleDNAType], 'isagSNP');
  }

  getDNAOrderTypeNames(dnaOrder: Array<SampleDNAType>, order: string) {
    const orderTypes: Array<string> = dnaOrder.reduce((acc: Array<string>, item: SampleDNAType) => {
      if (Object.keys(item).find((key: string) => key === order) && Object.keys(item).length && item[order]) {
        acc.push((item as any).label);
      }
      return acc;
    }, []);
    if (orderTypes.length) {
      return orderTypes.join(', ')
    }
    return 'none';
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }
}
